// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2T36f","row":"Node_row__BJnGI","label":"Node_label__qcmJW","footer":"Node_footer__1ZQK7"};